module.exports = __webpack_public_path__ + "img/doggie.27c899ce.jpg";